import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import _ from 'lodash';

import Header from './components/Header'
import Body from './components/Body'

import './style.scss'

export default class ResultColumn extends Component {
    static propTypes = {
        activeRowIndex: PropTypes.string,
        compareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        data: PropTypes.array,
        handleCompareYearChange: PropTypes.func.isRequired,
        handleMouseLeaveRow: PropTypes.func.isRequired,
        handleRowHover: PropTypes.func.isRequired,
        handleSampleYearChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isAdvanced: PropTypes.bool.isRequired,
        openRows: PropTypes.array,
        sampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        sectionsDefinition: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                rows: PropTypes.arrayOf(
                    PropTypes.shape({
                        prefix: PropTypes.string,
                        highlight: PropTypes.bool,
                        text: PropTypes.string.isRequired,
                        columnCode: PropTypes.string.isRequired,
                        indentationLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        configuration: PropTypes.shape({
                            unit: PropTypes.string,
                            higherIsBetter: PropTypes.string,
                        }),
                    })
                ).isRequired,
            })
        ),
        setYears: PropTypes.func.isRequired,
        tableType: PropTypes.string.isRequired,
        translates: PropTypes.shape({
            compareYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            sampleYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            yearDevelopment: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const {
            id,
            sectionsDefinition,
            data,
            activeRowIndex,
            handleMouseLeaveRow,
            handleSampleYearChange,
            handleCompareYearChange,
            setYears,
            handleRowHover,
            sampleYear,
            compareYear,
            openRows,
            isAdvanced,
            tableType,
            translates,
        } = this.props

        return (
            <div className={'finance-table-result-column'}>
                <div className={'result-column-header'}>
                    <Header
                        id={id}
                        data={data}
                        translates={translates}
                        compareYear={compareYear}
                        sampleYear={sampleYear}
                        handleCompareYearChange={handleCompareYearChange}
                        handleSampleYearChange={handleSampleYearChange}
                        setYears={setYears}
                        tableType={tableType}
                    />
                </div>
                <div className={'result-column-body'}>
                    <Body
                        id={id}
                        data={data}
                        activeRowIndex={activeRowIndex}
                        handleMouseLeaveRow={handleMouseLeaveRow}
                        handleRowHover={handleRowHover}
                        sampleYear={sampleYear}
                        compareYear={compareYear}
                        openRows={openRows}
                        isAdvanced={isAdvanced}
                        sectionsDefinition={sectionsDefinition}
                    />
                </div>
            </div>
        )
    }
}
